module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("First published in Great Britain in 2015 by"), _c('br'), _vm._v("\nPen & Sword Military"), _c('br'), _vm._v("\nan imprint of"), _c('br'), _vm._v("\nPen & Sword Books Ltd"), _c('br'), _vm._v("\n47 Church Street"), _c('br'), _vm._v("\nBarnsley"), _c('br'), _vm._v("\nSouth Yorkshire"), _c('br'), _vm._v("\nS70 2AS")])]), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Copyright © Evan McGilvray 2015")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("ISBN: 978 1 78159 076 8"), _c('br'), _vm._v("\nEPUB ISBN: 978 1 47385 493 2"), _c('br'), _vm._v("\nPRC ISBN: 978 1 47385 499 4")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("The right of Evan McGilvray to be identified as the Author of this"), _c('br'), _vm._v("\nWork has been asserted by him in accordance with the Copyright,"), _c('br'), _vm._v("\nDesigns and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("A CIP catalogue record for this book is available from the British"), _c('br'), _vm._v("\nLibrary")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or"), _c('br'), _vm._v("\ntransmitted in any form or by any means, electronic or mechanical"), _c('br'), _vm._v("\nincluding photocopying, recording or by any information storage and"), _c('br'), _vm._v("\nretrieval system, without permission from the Publisher in writing.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Typeset in Ehrhardt by"), _c('br'), _vm._v("\nMac Style Ltd, Bridlington, East Yorkshire"), _c('br'), _vm._v("\nPrinted and bound in the UK by CPI Group (UK) Ltd,"), _c('br'), _vm._v("\nCroydon, CRO 4YY")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Pen & Sword Books Ltd incorporates the imprints of Pen & Sword"), _c('br'), _vm._v("\nArchaeology, Atlas, Aviation, Battleground, Discovery, Family"), _c('br'), _vm._v("\nHistory, History, Maritime, Military, Naval, Politics, Railways, Select,"), _c('br'), _vm._v("\nTransport, True Crime, and Fiction, Frontline Books, Leo Cooper,"), _c('br'), _vm._v("\nPraetorian Press, Seaforth Publishing and Wharncliffe.")])]), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("For a complete list of Pen & Sword titles please contact"), _c('br'), _vm._v("\nPEN & SWORD BOOKS LIMITED"), _c('br'), _vm._v("\n47 Church Street, Barnsley, South Yorkshire, S70 2AS, England"), _c('br'), _vm._v("\nE-mail: ")]), _c('a', {
    attrs: {
      "href": "mailto:enquiries@pen-and-sword.co.uk"
    }
  }, [_vm._v("enquiries@pen-and-sword.co.uk")]), _c('br'), _vm._v("\nWebsite: "), _c('a', {
    attrs: {
      "href": "http://www.pen-and-sword.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.pen-and-sword.co.uk")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f8513ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Copyright.vue
// module id = 63
// module chunks = 0